import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import getPublicFeatures from '../../api/getPublicFeatures';
import ACTIONS from '../../../state/authentication/constants';

export default function usePublicFeatures() {
    const dispatch = useDispatch();
    useEffect(() => {
        const fetchPublicFeatures = async () => {
            const publicFeaturesResponse = await getPublicFeatures();
            dispatch({
                type: ACTIONS.FEATURES_SET,
                features: publicFeaturesResponse?.features ?? []
            });
        };
        fetchPublicFeatures();
    }, []);
}
